<template>
    <div class="container" v-cloak>
        <div v-if="gift != null">
            <my-point :point="user.points" v-if="loggedIn"></my-point>

            <div class="row justify-content-center">
                <div class="col-10 text-center my-3">
                    <img :src="gift.image" class="img-fluid">
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <h4>{{ gift.name }}</h4>
                </div>
                <div class="col">
                    <div class="bg-yellow width-fit-content">
                        {{ totalPoints }}分
                    </div>
                </div>
            </div>

            <hr>

            <div class="row mb-2">
                <div class="col-12">
                    <div class="title">禮品詳情：</div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="small text-muted" v-html="gift.description"></div>
                </div>
            </div>

            <hr>

            <div class="row mb-2">
                <div class="col-12">
                    <div class="title">使用條款及細則：</div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="small text-muted " v-html="gift.terms"></div>
                </div>
            </div>

            <div class="button-container text-center disabled" v-if="!loggedIn">
                <a @click="redirectToAppLogin()" class="btn btn-block">登入換領禮品</a>
            </div>

            <div class="button-container text-center disabled" v-else-if="!gift.started">
                未開始可以兌換
            </div>

            <div class="button-container text-center disabled text-danger" v-else-if="gift.expired">
                禮品已過期
            </div>

            <div class="button-container text-center disabled" v-else-if="redeemed">
                已換領
            </div>

            <div class="button-container text-center disabled" v-else-if="!target_member">
                只限新會員
            </div>

            <div class="button-container text-center disabled" v-else-if="user.points < totalPoints">
                沒有足夠積分
            </div>

            <div class="button-container text-center disabled text-danger" v-else-if="gift.out_of_stock">
                已換罄
            </div>

            <div class="button-container text-center" v-else>
                <a @click="showRedeemForm = true" class="btn btn-block">換領</a>
            </div>
        </div>

        <div class="redeem-form" :class="{ 'active': showRedeemForm }">
            <mobile-verification
                v-if="user.mobile == null"
                @mobileVerified="onMobileVerified"
            ></mobile-verification>

            <div class="row mb-5" v-if="user.mobile != null">
                <div class="col-12">
                    <ValidationObserver v-slot="{ invalid }">
                        <form @submit.prevent="onSubmit()">
                            <!-- <div class="form-group" v-if="maxQuantity > 1">
                                <label for="quantity">數量</label>
                                <input type="number" class="form-control" value="1" min="1" :max="maxQuantity" step="1" v-model="quantity"/>
                            </div> -->
                            <p class="tos text-muted"><small>繼續即代表你已閱讀及明白有關註冊的<a href="https://www.speakout.hk/%E7%B6%B2%E7%AB%99%E4%BF%A1%E6%81%AF/%E5%85%8D%E8%B2%AC%E6%A2%9D%E6%AC%BE">《條款及細則》</a>、<a href="https://www.speakout.hk/%E7%B6%B2%E7%AB%99%E4%BF%A1%E6%81%AF/%E7%A7%81%E9%9A%B1%E8%81%B2%E6%98%8E">《私隱政策聲明》</a>及《收集個人資料聲明》，並同意接受其約束。</small></p>

                            <div v-if="gift.redeem_type == 'physical'">
                                <div class="form-group">
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <label for="quantity">收件人姓名</label>
                                        <input type="text" class="form-control" :class="{ 'is-invalid': errors.length > 0 }" id="name" name="name" v-model="form.name" placeholder="請輸入收件人姓名"/>
                                        <small class="invalid-feedback">
                                            請輸入收件人姓名
                                        </small>
                                    </ValidationProvider>
                                </div>

                                <div class="form-group">
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <label for="quantity">收件人地址</label>
                                        <textarea class="form-control" :class="{ 'is-invalid': errors.length > 0 }" id="address" name="address" rows="5" v-model="form.address" placeholder="請輸入收件地址"></textarea>
                                        <small class="invalid-feedback">
                                            請輸入收件人地址
                                        </small>
                                    </ValidationProvider>

                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="set_default_address" name="set_default_address" v-model="set_default_address">
                                        <label class="form-check-label" for="set_default_address">
                                            預設為帳號地址
                                        </label>
                                    </div>

                                    <p>
                                        <small>請確保收件人姓名及地址準確無誤。如因所提供的郵寄資料錯誤或郵遞失誤而導致寄失或延遲，恕不補發禮品。</small>
                                    </p>
                                </div>
                            </div>

                            <button type="submit" class="btn btn-block btn-speakout" :disabled="invalid || recaptcha_token == null || form.mobile == null">確認</button>
                        </form>
                    </ValidationObserver>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Autentication from './mixins/authentication'
import User from './mixins/user'
import RedirectToLogin from './mixins/redirectToLogin'
import MyPoint from './MyPoint'
import MobileVerification from './MobileVerification'

export default {
    name: 'gift-detail',

    props: [
        'giftId'
    ],

    mixins: [
        Autentication,
        User,
        RedirectToLogin
    ],

    components: {
        'my-point': MyPoint,
        'mobile-verification': MobileVerification
    },

    computed: {
        totalPoints() {
            return this.quantity * this.gift.points;
        },

        maxQuantity() {
            const maxRedeemQuantity = Math.floor(this.user.points / this.gift.points);

            return maxRedeemQuantity > this.gift.max_redeem ? this.gift.max_redeem : maxRedeemQuantity;
        }
    },

    mounted() {
        this.initRecaptcha()
    },

    async created() {
        await this.authentication()

        if (this.loggedIn) {
            await this.getUser()
            this.setFormData()
        }

        await this.getGift()
    },

    data() {
        return {
            'user': {
                name: null,
                mobile: null,
                address: null,
                points: 0,
                redeemedCodes: []
            },
            'gift': {
                points: 0,
                out_of_stock: false
            },
            'redeemed': false,
            'target_member': false,
            'quantity': 1,
            'showRedeemForm': false,
            'recaptcha_token': '',
            'set_default_address': false,
            'form': {
                mobile: null,
                name: null,
                address: null,
            }
        }
    },

    methods: {
        setFormData() {
            this.form.address = this.user.address
            this.form.mobile = this.user.mobile
            this.form.name = this.user.name
        },

        async initRecaptcha() {
            await this.$recaptchaLoaded()

            const token = await this.$recaptcha('redeem')

            if (token) {
                this.recaptcha_token = token;

                return
            }

            this.recaptcha_token = null;
        },

        async getGift() {
            try {
                let identity = ''

                if (!this.loggedIn) {
                    identity = "/guest"
                }

                const { data } = await axios.get(`/gifts/${this.giftId}${identity}`);
                const { gift, redeemed, target_member } = data;

                this.gift = gift;
                this.redeemed = redeemed;
                this.target_member = target_member;
            } catch (error) {
                console.log(error)
            }
        },

        onMobileVerified(mobile) {
            this.user.mobile = mobile
            this.form.mobile = mobile
        },

        async onSubmit() {
            try {
                const { data, status } = await axios.post(`/gifts/redeem`, {
                                    'gift_id': this.gift.id,
                                    'recaptcha_token': this.recaptcha_token,
                                    'quantity': this.quantity,
                                    'name': this.form.name,
                                    'mobile': this.form.mobile,
                                    'address': this.form.address,
                                    'set_default_address': this.set_default_address
                                })
                if (status == 200) {
                    this.onRedeemed()
                }
            } catch (error) {
                alert('發生錯誤，請稍後再試！')
            }
        },

        onRedeemed() {
            Swal.fire({
                title: '成功換領！',
                text: '您已經成功換領禮品，請至「我的禮品」查看詳情',
                imageUrl: this.gift.image,
                imageWidth: '100%',
                imageAlt: this.gift.name,
                confirmButtonText: '好的',
            }).then(result => {
                window.location.href="/?type=my"
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.width-fit-content {
    width: fit-content;
    padding: 3px;
}

.title {
    color: #1e6940;
    font-weight: bold;
}

.collapse-button {
    text-decoration: none;
    color: #000000;
}

.redeem-form {
    position: fixed;
    top: 0;
    left: -100%;
    z-index: 999;

    background: #EDEDED;
    width: 100%;
    height: 100%;
    padding: 10px;

    &.active {
        animation: slide 0.5s forwards;

        @keyframes slide {
            100% { left: 0; }
        }
    }

    .tos {
        a {
            color:#000000;
        }
    }
}
</style>
